module.exports = __webpack_public_path__ + "img/faloo.fdf1d3db.svg";